import * as getters from './getters';

import actions from './actions';
import mutations from './mutations';

const state = () => ({
  showMobileBottomNavigation: true,
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
